<svg viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
  <path fill-rule="evenodd" clip-rule="evenodd" d="M39.0129 20.0894H29.9817V36.097H19.0291V20.0894H9.01953L24.1351 5L39.0129 20.0894ZM9 40V44H39V40H9Z" />
</svg>
